<script>
    import { flip } from 'svelte/animate';
    import { tcc_json } from '$lib/static/tcc_json.js';
    import { tooltip } from '$lib/app/tooltip.js';
    import { expoOut } from 'svelte/easing';

    let {
        user_tcc,
        size = 32, // for capacitor
    } = $props();

    const tcc_to_continents = {
        "AFR": "Africa",
        "ANT": "Antarctica",
        "ASI": "Asia", "MID": "Asia",
        "CAM": "North America", "CRB": "North America", "NAM": "North America",
        "EUR": "Europe",
        "PAC": "Australia and Oceania",
        "SAM": "South America"
    };

    const continents_i = {
        "Europe": "europe.png",
        "North America": "north-america.png",
        "Asia": "asia.png",
        "Africa": "africa.png",
        "South America": "south-america.png",
        "Australia and Oceania": "australia.png",
        "Antarctica": "antarctica.png"
    }

    let visited_continents = $derived.by(() => {
        let visited_continents = {};
        if(user_tcc) {
            for (const reg of tcc_json) {
                if(!visited_continents[tcc_to_continents[reg.reg]]) {
                    visited_continents[tcc_to_continents[reg.reg]] = reg.db.some((x) => user_tcc[x.id] > 0);
                }
            }
        }
        return visited_continents;
    });

    let continents_arr = $derived.by(() => {
        const continents_arr = Object.keys(continents_i).map(continent => {
            return {
                id: continent,
                visited: !!visited_continents[continent],
                url: visited_continents[continent] ? '/i/c/'+continents_i[continent] : '/i/bw/'+continents_i[continent]
            };
        });

        return [
            ...continents_arr.filter(c => c.visited),
            ...continents_arr.filter(c => !c.visited)
        ];
    });
</script>

<div class="container">
    {#each continents_arr as continent (continent.id)}
        <span   use:tooltip
                data-tooltip={continent.visited ? `${continent.id} ✓` : `${continent.id} ❌`}
                animate:flip={{duration:400, easing:expoOut}}
        ><img src={continent.url} alt={continent.visited ? `${continent.id} ✓` : `${continent.id} ❌`} width={size} height={size}/></span>
    {/each}
</div>


<style>
.container {
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
}
</style>
